import React, { useState, useEffect } from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { RecordsContainer, NavigatorContainer, Navigator } from './styles';

const LastLogin = ({ records }) => {
  
  const [pageNumber, setPageNumber] = useState(1)
  const pageSize = 3
  const pageCount = Math.ceil(records?.length/pageSize)

  useEffect(() => {
    setPageNumber(1)
  }, [records])

  const paginate = (array, page_size, page_number) => {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array?.slice((page_number - 1) * page_size, page_number * page_size);
  }

  const previousPage = () => {
    if(pageNumber > 1) {
      setPageNumber((pageNumber) => pageNumber-1)
    }
  }

  const nextPage = () => {
    if(pageNumber < pageCount) {
      setPageNumber((pageNumber) => pageNumber+1)
    }
  }

  const displayedRecords = records.length ? (
    (paginate(records, pageSize, pageNumber) || []).map((booking, index) => {
      const { createdAt, device, ipAddress, location } = booking;
      return (
        <tr key={index}>
          <td>{moment(createdAt).tz(TIME_ZONE).format('MMM Do YYYY, HH:mm A')}</td>
          <td>{device}</td>
          <td>{ipAddress}</td>
          <td>{location}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={4} style={{ textAlign: 'center' }}>No records found</td>
    </tr>
  )

  return (
    <Card>
      <CardHeader>
        <div className="cardTitle">Last Login</div>
      </CardHeader>
      {records?.length > pageSize ? (
        <NavigatorContainer>
          <Navigator
            disabled={pageNumber <= 1}
            onClick={previousPage}
          >
            {"<"} Back
          </Navigator>
          <Navigator
            disabled={pageNumber >= pageCount}
            onClick={nextPage}
          >
            Next {">"}
          </Navigator>
        </NavigatorContainer>
      ) : null}
      <RecordsContainer>
        <table>
          <thead>
            <tr>
              <th className='dateTime'>LOGIN DATE AND TIME</th>
              <th className='device'>DEVICE</th>
              <th className='ipAddress'>IP ADDRESS</th>
              <th className='location'>LOCATION</th>
            </tr>
          </thead>
          <tbody>
            {displayedRecords}
          </tbody>
        </table>
      </RecordsContainer>
    </Card>
  );
};

export default LastLogin;
